import React from "react";

import type { RowData } from "@tanstack/react-table-v9";

import TableV2IconButton from "./TableV2IconButton";
import type { TableV2Instance } from "../hooks/useTableV2";

/** Header icon that flips between the table and pivot views */
const TableV2ViewSwitch = <TData extends RowData>({
  table,
}: {
  table: TableV2Instance<TData>;
}) => {
  const extras = table.v2;
  if (!extras?.pivot) return null;
  const next = extras.view === "pivot" ? "table" : "pivot";

  return (
    <TableV2IconButton
      icon={next === "pivot" ? "fa-solid fa-table-pivot" : "fa-solid fa-table"}
      label={next === "pivot" ? "Pivot view" : "Table view"}
      onClick={() => extras.setView(next)}
    />
  );
};

export default TableV2ViewSwitch;
